import React from "react";
import OrdersListModal from "./OrdersListModal";

export default function CloseOrdersModal(props) {
  return (
    <OrdersListModal
      title="Zlecenia do Zamknięcia"
      variant="close"
      primaryLabel="Zamknij"
      emptyText="Brak zleceń do zamknięcia."
      {...props}
    />
  );
}
